import React from 'react'
import { Link } from 'react-router-dom'
import styles from './index.module.css'

import TruncatedText from 'components/common/truncated-text'

import type { SourceCell } from '../helpers'

type Props = {
  source: SourceCell
}
export default function SourceLink({ source }: Props): React.ReactNode {
  // Truncation lives inside the link, so a long source name clips to one line
  // and reveals itself on hover rather than widening the column.
  const text = <TruncatedText>{source.sourceText}</TruncatedText>

  if (source.sourceLink) {
    return (
      <Link
        className={`inline-link ${styles.SourceLink}`}
        to={source.sourceLink}
      >
        {text}
      </Link>
    )
  } else {
    return <span className={styles.plainSource}>{text}</span>
  }
}
